<template>
  <render />
</template>

<script setup lang="ts">
import { h, useSlots, computed } from 'vue'

interface Props {
  keypath: string
  tag?: string
  scope: string
}

const props = defineProps<Props>()
const slots = useSlots()

const parsedParts = computed(() => {
  const text = t(props.keypath, props.scope)
  const regex = /\{(\w+)\}/g
  const parts = []
  let lastIndex = 0
  let match

  while ((match = regex.exec(text)) !== null) {
    if (match.index > lastIndex) {
      parts.push({ type: 'text', content: text.slice(lastIndex, match.index) })
    }
    parts.push({ type: 'slot', name: match[1] })
    lastIndex = regex.lastIndex
  }
  if (lastIndex < text.length) {
    parts.push({ type: 'text', content: text.slice(lastIndex) })
  }
  return parts
})

const render = () => {
  const children = parsedParts.value.map((part: any) => {
    if (part.type === 'slot') {
      const slotContent = slots[part.name]?.()
      return slotContent || h('span', `{${part.name}}`)
    }
    return h('span', part.content)
  })

  return h(props.tag ? props.tag : 'span', {}, children)
}
</script>
